var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.418 1.629a5 5 0 0 0-5.946.832L1 3.844V2a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H1.762l1.4-1.315.011-.01a4 4 0 1 1-.946 4.16.5.5 0 0 0-.944.331A5 5 0 1 0 8.418 1.63zM6.5 3.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .276.448l2 1a.5.5 0 0 0 .448-.895L6.5 6.191v-2.69z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentIcon);
export default __webpack_public_path__ + "static/media/recentIcon.af93a485cee0b005fd3878cbc9ee6ddc.svg";
export { ForwardRef as ReactComponent };